import type {
  OrderCostDetailState,
  OrderCostLine,
  OrderCostReviewer,
} from "./types";

export type OrderCostReviewHighlightStatus =
  | "PENDING"
  | "REQUEST_EDIT"
  | "REJECTED";

export type OrderCostReviewHighlightReviewer = OrderCostReviewer;

export const getActiveOrderCostReviewer = (
  state?: OrderCostDetailState | null,
): OrderCostReviewHighlightReviewer | null => {
  if (state === "WAITING_APPROVE_L1") return "sale";
  if (state === "WAITING_APPROVE_L2") return "manager";
  return null;
};

export const getOrderCostReviewHighlightStatus = (
  record: OrderCostLine,
  state?: OrderCostDetailState | null,
): OrderCostReviewHighlightStatus | null => {
  const reviewer = getActiveOrderCostReviewer(state);
  if (!reviewer || !record?.isLeaf || !record.values?.actual?.value) return null;

  const status = record.reviews?.[reviewer]?.status;

  if (
    status === "PENDING" ||
    status === "REQUEST_EDIT" ||
    status === "REJECTED"
  ) {
    return status;
  }

  return null;
};
